import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.fabricationJobs.FabricationJobListView.';
  public static readonly allCurrentTabTitle = `${Id.prefix}allCurrentTabTitle`;
  public static readonly draftTabTitle = `${Id.prefix}draftTabTitle`;
  public static readonly plannedTabTitle = `${Id.prefix}plannedTabTitle`;
  public static readonly awaitingOrderTabTitle = `${Id.prefix}awaitingOrderTabTitle`;
  public static readonly readyForProductionTabTitle = `${Id.prefix}readyForProductionTabTitle`;
  public static readonly inProductionTabTitle = `${Id.prefix}inProductionTabTitle`;
  public static readonly completedTabTitle = `${Id.prefix}completedTabTitle`;
  public static readonly createFabricationJob = `${Id.prefix}createFabricationJob`;
  public static readonly cannotDeleteTitle = `${Id.prefix}cannotDeleteTitle`;
  public static readonly cannotDeleteMessage = `${Id.prefix}cannotDeleteMessage`;
}

export class LangFabricationJobListView {
  private constructor() {}
  public static allCurrentTabTitle(): string {
    return interpolate(Id.allCurrentTabTitle);
  }
  public static draftTabTitle(): string {
    return interpolate(Id.draftTabTitle);
  }
  public static plannedTabTitle(): string {
    return interpolate(Id.plannedTabTitle);
  }
  public static awaitingOrderTabTitle(): string {
    return interpolate(Id.awaitingOrderTabTitle);
  }
  public static readyForProductionTabTitle(): string {
    return interpolate(Id.readyForProductionTabTitle);
  }
  public static inProductionTabTitle(): string {
    return interpolate(Id.inProductionTabTitle);
  }
  public static completedTabTitle(): string {
    return interpolate(Id.completedTabTitle);
  }
  public static createFabricationJob(): string {
    return interpolate(Id.createFabricationJob);
  }
  public static cannotDeleteTitle(): string {
    return interpolate(Id.cannotDeleteTitle);
  }
  public static cannotDeleteMessage(): string {
    return interpolate(Id.cannotDeleteMessage);
  }
}

export class FabricationJobListViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.allCurrentTabTitle, 'All Current', 'Tab title for all current fabrication jobs');
    register.add(Id.draftTabTitle, 'Draft', 'Tab title for draft fabrication jobs');
    register.add(Id.plannedTabTitle, 'Planned', 'Tab title for planned fabrication jobs');
    register.add(Id.awaitingOrderTabTitle, 'Awaiting Order', 'Tab title for fabrication jobs awaiting order');
    register.add(
      Id.readyForProductionTabTitle,
      'Ready for Production',
      'Tab title for fabrication jobs ready for production'
    );
    register.add(Id.inProductionTabTitle, 'In Production', 'Tab title for fabrication jobs in production');
    register.add(Id.completedTabTitle, 'Completed', 'Tab title for completed fabrication jobs');
    register.add(Id.createFabricationJob, 'Create Fabrication Job', 'Button text to create a new fabrication job');
    register.add(Id.cannotDeleteTitle, 'Cannot Delete', 'Title for cannot delete dialog');
    register.add(
      Id.cannotDeleteMessage,
      'This fabrication job is currently being edited by another user and cannot be deleted.',
      'Message when fabrication job cannot be deleted due to concurrent edit'
    );
  }
}
